import { ListLoadingPlaceholderListItems } from 'modules/list/listPage/ListLoadingPlaceholder/ListLoadingPlaceholderListItems';
import FlexGrid from '../../../components/FlexGrid';
import { MovingGradient } from '../../../components/MovingGradient';
import PaddingBox from '../../../components/PaddingBox';
import { isMobile } from '../../../utils/device';
import { ListLayout } from '../../list/components/ListLayout';

export const PublicDocumentListLoadingPlaceholder = () => (
	<ListLayout>
		<PaddingBox
			topExtraLarge={!isMobile}
			topSmall={isMobile}
		>
			<MovingGradient
				style={{
					margin: '0 auto',
				}}
				width={isMobile ? '50%' : '20%'}
				height='26px'
			/>
		</PaddingBox>
		<PaddingBox
			topSmall
			bottomMedium
		>
			<MovingGradient
				style={{
					margin: '0 auto',
				}}
				width={isMobile ? '70%' : '30%'}
				height='18px'
			/>
		</PaddingBox>
		<FlexGrid
			center
			hrCenter
		>
			<div style={{ maxWidth: '960px', width: '100%' }}>
				{/* <ListItemsPlaceholder itemsCount={5} /> */}
				<ListLoadingPlaceholderListItems
					columnsCount={6}
					skipNavigation
					rowsCount={4}
					skipCollapse
				/>
			</div>
		</FlexGrid>
	</ListLayout>
);
